module.exports = __webpack_public_path__ + "static/img/pinggu-0111.5dae9f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pinggu-0111.png
// module id = O7l8
// module chunks = 1